<!-- 员工新增与编辑弹窗，维护基础资料、身份证识别、佣金配置及登录账号。 -->
<template>
  <div>
    <Modal
      :title="formData.id ? '编辑员工' : '新增员工'"
      v-model="visible"
      width="1300"
      class="my-modal top add-user-wrap"
      :mask-closable="false"
      :footer-hide="true"
    >
      <Form ref="form" v-if="visible" :model="formData" class="page-form" :label-width="95">
        <h2>基础信息</h2>
        <FormItem label="所属转介人" prop="tenantId" :rules="$units.formRule.required('请选择')">
          <selectTree
            v-if="merchantType == 3"
            v-model="formData.tenantId"
            type="5"
            url="/buz/merchant/read/tree"
            :params="{ nodeType: 0 }"
            :isAll="true"
            :disabled="!!formData.id"
            immediate
            :clearable="false"
            ref="selectTree"
          />
          <span v-else> {{ formData.orgName }}</span>
        </FormItem>

        <FormItem v-if="isIFA && formData.groupName" label="所属团队" key="groupId" prop="groupId">
          {{ formData.groupName }}
        </FormItem>
        <FormItem v-else-if="merchantType != 3 && !isIFA" label="所属团队" key="groupIds" prop="groupId">
          <Select v-model="formData.groupId" clearable @on-change="changeGroupId" filterable>
            <Option v-for="(bean, i) in groupList" :key="i" :value="bean.id">
              {{ bean.name }}
            </Option>
          </Select>
        </FormItem>
        <template v-if="isIFA">
          <FormItem prop="ifaType" key="groupId1" label="账号类型" :rules="$units.formRule.required('请选择', 'change', 'number')">
            <RadioGroup v-model="formData.ifaType" @on-change="changeIfaType">
              <Radio :label="1">正式</Radio>
              <Radio :label="2">潜在</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem prop="staffNo" label="工号" key="staffNo" :rules="$units.formRule.required('请输入', 'blur')">
            <Input v-model="formData.staffNo" placeholder="请输入" />
          </FormItem>
          <FormItem prop="name" label="中文姓名" key="name" :rules="$units.formRule.required('请输入', 'blur')">
            <Input v-model="formData.name" placeholder="请输入">
              <!-- 选择大陆或香港身份证图片后，回填当前员工已有的身份资料。 -->
              <idcardOcr slot="suffix" @ok="saveIdcardInfo" />
            </Input>
          </FormItem>
          <FormItem prop="signNamePinyin" label="身份证姓名（拼音）" :label-width="150" :rules="signNamePinyinRule">
            <Input v-model="formData.signNamePinyin" maxlength="30" placeholder="请输入身份证姓名（拼音），最多30字符"
              @on-change="onSigningPinyinEdited" @on-blur="normalizeSigningPinyin" />
          </FormItem>
          <FormItem prop="englishName" label="英文名" key="englishName" :rules="$units.formRule.required('请输入', 'blur')">
            <Input v-model="formData.englishName" placeholder="请输入" />
          </FormItem>
          <FormItem
            label="入职时间"
            key="entryTime"
            prop="entryTime"
            :rules="formData.ifaType == '1' ? $units.formRule.objRequired('请选择') : { required: false }"
          >
            <DatePicker v-model="formData.entryTime" type="date" transfer placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" />
          </FormItem>
          <FormItem prop="ifaLevel" label="销售职级" key="ifaLevel" :rules="$units.formRule.required('请选择')">
            <lzDicSelect :disabled="!!formData.id" v-model="formData.ifaLevel" dicType="IFA_RANK" :transfer="true" clearable @change="changeIfaLevel">
            </lzDicSelect>
          </FormItem>

          <FormItem v-if="merchantType != 3" key="isLeader" prop="isLeader" label="是否团队长" :rules="$units.formRule.required('请选择')">
            <!-- 机构下直接新增员工的是否团队长只能选否 -->
            <RadioGroup v-model="formData.isLeader" @on-change="changeIsLeader">
              <Radio label="1" :disabled="!!formData.id">是</Radio>
              <Radio label="0" :disabled="!!formData.id">否</Radio>
            </RadioGroup>
          </FormItem>

          <FormItem
            prop="firstLicenceTime"
            label="首次挂牌时间"
            :label-width="120"
            :rules="formData.ifaType == 1 ? $units.formRule.objRequired('请选择') : { required: false }"
          >
            <DatePicker v-model="formData.firstLicenceTime" type="date" transfer placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" />
          </FormItem>
          <FormItem
            prop="isLongCareer"
            label="空档期是否大于6个月"
            :label-width="150"
            :rules="formData.ifaType == 1 ? $units.formRule.required('请选择', 'change', 'number') : { required: false }"
          >
            <RadioGroup v-model="formData.isLongCareer">
              <Radio :label="1">是</Radio>
              <Radio :label="0">否</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem
            v-if="formData.isLeader == '1'"
            prop="groupLevel"
            key="groupLevel"
            label="团队长级别"
            :rules="$units.formRule.required('请选择团队长级别', 'change', 'number')"
          >
            <RadioGroup v-model="formData.groupLevel">
              <Radio :label="1" :disabled="!!formData.id">合伙人</Radio>
              <Radio :label="2" :disabled="!!formData.id">高级合伙人</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem v-if="formData.isLeader !== '1'" key="leaderId" label="团队长" prop="leaderId">
            <Select v-model="formData.leaderId" transfer clearable @on-change="changeLeaderId">
              <Option v-for="(item, index) in groupUserList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="推荐人" prop="refereeId" key="refereeId">
            <Select v-model="formData.refereeId" transfer clearable filterable>
              <Option v-for="(item, index) in refereeList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="辅导人" prop="mentorId" key="mentorId">
            <Select v-model="formData.mentorId" transfer clearable filterable>
              <Option v-for="(item, index) in mentorList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="育成人" prop="trainerId" key="trainerId">
            <Select v-model="formData.trainerId" transfer clearable filterable>
              <Option v-for="(item, index) in trainerList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem
            label="licence有效期"
            key="type"
            prop="date"
            :label-width="120"
            :rules="formData.ifaType == 1 ? $units.formRule.arrRequired('请选择licence有效期', 'change') : { required: false }"
          >
            <DatePicker
              v-model="formData.date"
              type="daterange"
              separator="至"
              transfer
              :editable="false"
              placement="bottom"
              format="yyyy-MM-dd"
              placeholder="选择日期"
            />
          </FormItem>
        </template>
        <template v-else>
          <FormItem prop="name" label="姓名" key="name" :rules="$units.formRule.required('请输入', 'blur')">
            <Input v-model="formData.name" placeholder="请输入" />
          </FormItem>
          <FormItem prop="signNamePinyin" label="英文拼音" :rules="signNamePinyinRule">
            <Input v-model="formData.signNamePinyin" maxlength="30" placeholder="请输入英文拼音（签单用），最多30字符"
              @on-change="onSigningPinyinEdited" @on-blur="normalizeSigningPinyin" />
          </FormItem>
          <FormItem v-if="merchantType != 3" key="isLeader" prop="isLeader" label="是否团队长" :rules="$units.formRule.required('请选择')">
            <!-- 机构下直接新增员工的是否团队长只能选否 -->
            <RadioGroup v-model="formData.isLeader" @on-change="changeIsLeader">
              <Radio label="1" :disabled="!formData.groupId">是</Radio>
              <Radio label="0" :disabled="!formData.groupId">否</Radio>
            </RadioGroup>
          </FormItem>
        </template>

        <!-- 掩码手机号 -->
        <FormItem prop="mobile" label="手机号" key="mobile1" v-if="formData.id && formData.mobile && !formData.mobileEyeShow">
          <span @dblclick="openEye(formData, 'mobile')">{{ formData.mobile }}</span>
          <a>
            <i class="iconfont iconyincang" @click="openEye(formData, 'mobile')"></i>
          </a>
        </FormItem>
        <FormItem v-else prop="mobile" label="手机号" key="mobile2" :rules="[validMobile]">
          <Input v-model="formData.mobile" placeholder="请输入" />
        </FormItem>

        <FormItem label="证件类型" prop="idType" key="idType">
          <Select v-model="formData.idType" transfer clearable @on-change="$set(formData, 'idNo', '')">
            <Option v-for="(item, index) in idTypeList" :value="item.value" :key="index">{{ item.txt }}</Option>
          </Select>
        </FormItem>
        <FormItem label="证件号" v-if="formData.id && formData.idNo && !formData.idNoEyeShow" key="idNo0">
          <span @dblclick="openEye(formData, 'idNo')">{{ formData.idNo }}</span>
          <a>
            <i class="iconfont iconyincang" @click="openEye(formData, 'idNo')"></i>
          </a>
        </FormItem>
        <FormItem
          prop="idNo"
          label="证件号"
          :rules="$units.formRule.idCard('请输入正确的身份证号', false, 'blur')"
          v-else-if="formData.idType == '01'"
          key="idNo1"
        >
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <FormItem prop="idNo" label="证件号" :rules="strLength()" v-else-if="formData.idType == '02'" key="idNo2">
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <FormItem
          prop="idNo"
          label="证件号"
          :rules="$units.formRule.strLength('请输入正确的通行证件号', 8, false)"
          v-else-if="formData.idType == '16'"
          key="idNo16"
        >
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <FormItem prop="idNo" label="证件号" v-else-if="formData.idType == '07'" key="idNo7">
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <FormItem
          prop="idNo"
          label="证件号"
          key="idNo999"
          :rules="$units.formRule.strLength('请输入正确的外国人永久居留证件号', 15, false)"
          v-else-if="formData.idType == '999'"
        >
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <FormItem prop="idNo" label="证件号" v-else key="-">
          <Input v-model="formData.idNo" placeholder="请输入" />
        </FormItem>
        <!-- 仅IFA员工展示生日，位于证件号之后，支持手动选择及身份证识别回填。 -->
        <FormItem v-if="isIFA" prop="birthday" label="生日" key="birthday">
          <DatePicker
            :value="formData.birthday"
            type="date"
            transfer
            placement="bottom"
            format="yyyy-MM-dd"
            :editable="false"
            placeholder="选择日期"
            @on-change="$set(formData, 'birthday', $event)"
          />
        </FormItem>
        <FormItem prop="status" label="账号状态">
          <i-switch v-model="formData.status" size="large" true-value="1" false-value="0">
            <span slot="open">启用</span>
            <span slot="close">禁用</span>
          </i-switch>
        </FormItem>
        <FormItem v-if="isIFA && formData.ifaType == 1" prop="isLicence" label="持牌状态" :rules="$units.formRule.required('请选择', 'change', 'number')">
          <RadioGroup v-model="formData.isLicence" @on-change="changeIsLicence">
            <Radio :label="1">持牌中</Radio>
            <Radio :label="2">已下牌</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem
          v-if="isIFA && formData.isLicence == 1"
          prop="ifaLicenceNo"
          label="牌照編號"
          key="ifaLicenceNo"
          :rules="$units.formRule.required('请输入牌照编号', 'blur')"
        >
          <Input v-model="formData.ifaLicenceNo" placeholder="请输入" />
        </FormItem>
        <FormItem v-if="isIFA && formData.isLicence == 1" prop="ifaBusinessScope" label="業務系別" key="ifaBusinessScope">
          <Select v-model="formData.ifaBusinessScope" transfer clearable placeholder="请选择">
            <Option v-for="item in ifaBusinessScopeOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem
          v-if="isIFA && formData.isLicence == 2"
          prop="licenceEndDate"
          label="注销牌照日期"
          :label-width="120"
          key="licenceEndDate"
          :rules="$units.formRule.objRequired('请选择')"
        >
          <DatePicker v-model="formData.licenceEndDate" type="date" transfer placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" />
        </FormItem>
        <FormItem v-if="formData.id && isIFA" prop="activeStatus" key="activeStatus" label="active状态">
          <RadioGroup :disabled="!!formData.id" v-model="formData.activeStatus">
            <Radio :disabled="!!formData.id" label="1">是</Radio>
            <Radio :disabled="!!formData.id" label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem prop="account" label="电子邮箱" key="email1" v-if="formData.id && formData.email1 && !formData.emailEyeShow">
          <span @dblclick="openEye(formData, 'email')">{{ formData.email }}</span>
          <a>
            <i class="iconfont iconyincang" @click="openEye(formData, 'email')"></i>
          </a>
        </FormItem>
        <FormItem v-else label="电子邮箱" prop="email" key="email2" :rules="$units.formRule.email(false)">
          <lzEmailInput v-model="formData.email"></lzEmailInput>
        </FormItem>
        <template v-if="isIFA">
          <FormItem label="商务经理" prop="busserId" key="busserId" :rules="$units.formRule.required('请选择')">
            <Select v-model="formData.busserId" transfer clearable filterable placeholder="请选择">
              <Option v-for="(item, index) in busserList" :value="item.id" :key="index">{{ item.userName }}</Option>
            </Select>
          </FormItem>
          <FormItem label="自媒体运营" prop="operatorName" key="operatorName">
            <Input v-model="formData.operatorName" placeholder="请输入" />
          </FormItem>
          <FormItem label="凤鸣账号" prop="customerVid" key="customerVid">
            <Select v-model="formData.customerVid" transfer clearable filterable>
              <Option v-for="(item, index) in qwUserList" :value="item.customerVid" :key="index">{{ item.customerName }}</Option>
            </Select>
          </FormItem></template
        >
        <!-- 佣金配置板块：仅IFA账号显示，位于基础信息与账号信息之间 -->
        <template v-if="isIFA">
          <h2>佣金配置</h2>
          <FormItem prop="isCustomCommission" label="是否自定义佣金" :label-width="112" :rules="$units.formRule.required('请选择')">
            <RadioGroup v-model="formData.isCustomCommission" @on-change="changeCustomCommission">
              <Radio label="1">是</Radio>
              <Radio label="0">否</Radio>
            </RadioGroup>
          </FormItem>
          <!-- 选择"是"时展示销售佣金率输入框及说明文字 -->
          <FormItem class="two" v-if="formData.isCustomCommission == '1'" prop="customSaleCommissionRate" label="销售佣金率" :label-width="112" :rules="customRateRules">
            <div class="commission-rate-wrap">
              <span class="rate-eq">=</span>
              <Input v-model="formData.customSaleCommissionRate" class="rate-input" type="decimal" placeholder="请填写" />
              <span class="rate-symbol">%</span>
              <span class="rate-multi">×</span>
              <span class="rate-target">收佣佣金率</span>
            </div>
            <div class="commission-tip">
              例如：团队长为高级合伙人职级，销售佣金率自定义定义为50%*收佣佣金率；<br/>假设高级合伙人总包为92%，则团队利益佣金率 = (92%-50%) * 收佣佣金率
            </div>
          </FormItem>
        </template>
        <h2>账号信息</h2>
        <!-- 掩码账号 -->
        <FormItem prop="account" label="登录账号" key="account1" v-if="formData.id && formData.account && !formData.accountEyeShow">
          <span @dblclick="openEye(formData, 'account')">{{ formData.account }}</span>
          <a>
            <i class="iconfont iconyincang" @click="openEye(formData, 'account')"></i>
          </a>
        </FormItem>
        <FormItem
          prop="account"
          label="登录账号"
          key="account2"
          v-else
          :rules="[$units.formRule.required('请输入'), $units.formRule.str('不能含有特殊字符和标点符号'), forbidPureDigitsRule]"
        >
          <Input v-model="formData.account" placeholder="请输入" maxlength="20" />
        </FormItem>
        <FormItem v-if="!formData.id" key="password" prop="password" label="登录密码" :rules="$units.formRule.required('请输入', 'blur')">
          <Input v-model="formData.password" placeholder="请输入" type="password" />
        </FormItem>
        <FormItem v-if="!formData.id" key="password1" prop="password1" label="确认密码" :rules="$units.formRule.required('请输入', 'blur')" class="full">
          <Input v-model="formData.password1" placeholder="请输入" type="password" />
          <div class="info-text">密码8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种，且不能包含账号</div>
        </FormItem>
        <FormItem v-if="formData.id" key="password2" prop="password" label="登录密码">
          <Button type="primary" @click="$emit('editPassword', { id: formData.id })">修改密码</Button>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save" :loading="loading">确认</Button>
      </div>
    </Modal>
    <!-- 解密组件 -->
    <validUserName ref="validUserNameRef" @success="(...params) => openEye(...params)" />
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import lzDicSelect from '@/components/commons/lzDicSelect';
import lzEmailInput from '@/components/commons/lzEmailInput';
import validUserName from '@/components/commons/validUserName';
import idcardOcr from '@/components/commons/idcardOcr';
import { signNamePinyinFormMixin, isValidSignNamePinyin, normalizeSignNamePinyin } from '@/api/signNamePinyin';
export default {
  mixins: [common, signNamePinyinFormMixin],
  components: {
    selectTree,
    validUserName,
    idcardOcr,
    lzDicSelect,
    lzEmailInput
  },
  props: {},
  computed: {
    isIFA() {
      return this.userInfo.isIFA;
    },
    signNamePinyinRule() {
      const required = !(this.isIFA && this.formData.ifaType == 2);
      const label = this.isIFA ? '身份证姓名（拼音）' : '英文拼音（签单用）';
      const message = `${label}${required ? '必填，' : ''}最多30个字符`;
      return {
        required, trigger: 'blur', message,
        validator: (rule, value, callback) => callback(isValidSignNamePinyin(value, required) ? undefined
          : new Error(message))
      };
    },
    // 渠道类型
    merchantType() {
      return this.userInfo.merchantType;
    }
  },
  data() {
    return {
      userInfo: {},
      visible: false,
      loading: false,
      idTypeList: [], //证件类型
      groupList: [], //团队
      data: {},
      formData: {
        status: '1',
        isLeader: '0',
        mobile: '',
        name: '',
        // 员工生日，使用年月日格式提交。
        birthday: '',
        signNamePinyin: '',
        idNo: '',
        idType: '',
        account: '',
        password: '',
        password1: '',
        entryTime: '',
        ifaLevel: '',
        email: '',
        busserId: '',
        operatorName: '',
        firstLicenceTime: '',
        isLongCareer: null,
        licenceEndDate: '',
        ifaLicenceNo: '',
        ifaBusinessScope: null,
        isCustomCommission: '0',
        customSaleCommissionRate: null
      },
      validMobile: {
        required: false,
        message: '请输入手机号',
        trigger: 'blur',
        validator(rule, value) {
          if (!value) return true;
          if (!/^1[1023456789]\d{9}$/.test(value) && value.length != 8) {
            return false;
          }
          return true;
        }
      },

      forbidPureDigitsRule: {
        validator: (rule, value, callback) => {
          if (value) {
            // 限制字符串长度不小于6位
            if (value.length < 6) {
              callback(new Error('长度不能小于6位'));
              // } else if (/^[0-9]*$/.test(value)) {
              //   callback(new Error('不能为纯数字'));
            } else {
              callback();
            }
          } else {
            callback();
          }
        }
      },
      // 自定义销售佣金率校验规则：必填、数字、范围(0,100]
      customRateRules: [
        {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (value === null || value === undefined || value === '') {
              return callback(new Error('请填写销售佣金率'));
            }
            const num = Number(value);
            if (Number.isNaN(num)) {
              return callback(new Error('请输入数字'));
            }
            if (num <= 0 || num > 100) {
              return callback(new Error('销售佣金率需大于0且不大于100'));
            }
            callback();
          }
        }
      ],
      refereeList: [],
      trainerList: [],
      groupUserList: [],
      mentorList: [],
      userList: [],
      qwUserList: [],
      busserList: [],
      ifaBusinessScopeOptions: [
        { value: 1, label: '一般业务' },
        { value: 2, label: '长期业务（不包括相连长期业务）' },
        { value: 3, label: '长期业务（包括相连长期业务）' },
        { value: 4, label: '一般业务及长期业务（不包括相连长期业务）' },
        { value: 5, label: '一般业务及长期业务（包括相连长期业务）' }
      ]
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.getCardType();
    this.$nextTick(() => {
      this.$refs.selectTree && this.$refs.selectTree.openChange();
    });
  },
  methods: {
    /**
     * 将身份证识别结果回填到员工现有资料和生日字段。
     * @param {{name?: string, pinyin?: string, num?: string, birth?: string, idcardType?: 1|2}} data - 识别结果，出生日期格式为八位年月日，类型一为大陆身份证、二为香港身份证。
     * @returns {void} 无返回值。
     */
    saveIdcardInfo(data) {
      // 身份证识别类型与员工证件字典的对应关系。
      const idTypeMap = { 1: '01', 2: '07' };
      if (idTypeMap[data.idcardType]) { // 只回填已明确对应的身份证类型。
        this.$set(this.formData, 'idType', idTypeMap[data.idcardType]);
      }
      if (data.name) { // 未识别到姓名时保留当前录入值。
        this.$set(this.formData, 'name', data.name);
      }
      if (data.pinyin) { // 识别出的证件拼音按现有签单姓名规则整理，不用于英文名。
        this.$set(this.formData, 'signNamePinyin', normalizeSignNamePinyin(data.pinyin));
        this.onSigningPinyinEdited();
      }
      if (data.num) { // 新识别的证件号为明文，编辑时同步切换到可编辑输入框。
        this.$set(this.formData, 'idNo', data.num);
        this.$set(this.formData, 'idNoEyeShow', true);
      }
      if (data.birth) { // 仅使用接口返回的出生日期，不从证件号码推算。
        this.$set(this.formData, 'birthday', data.birth.substr(0, 4) + '-' + data.birth.substr(4, 2) + '-' + data.birth.substr(6, 2));
      }
    },
    changeIfaType() {
      if (this.formData.ifaType == 2) {
        this.$set(this.formData, 'isLicence', 0);
      }
      this.setStaffNo();
      // 切换账号类型后，实时更新身份证姓名和licence有效期的校验状态
      this.$nextTick(() => {
        const form = this.$refs.form;
        if (!form) return;
        form.validateField('signNamePinyin');
        if (this.formData.ifaType == 1) {
          // 正式账号：licence有效期必填，立即触发校验
          form.validateField('date');
        } else {
          // 潜在账号：非必填，清除已有错误提示
          const field = form.fields.find(f => f.prop === 'date');
          if (field) {
            field.validateState = '';
            field.validateMessage = '';
          }
        }
      });
    },
    // 持牌状态切换：切回持牌中时清空注销牌照日期
    changeIsLicence(val) {
      if (val == 1) {
        this.formData.licenceEndDate = '';
      }
    },
    // 是否自定义佣金切换联动：切回"否"时清空销售佣金率，避免提交脏数据
    changeCustomCommission(val) {
      if (val != '1') {
        this.$set(this.formData, 'customSaleCommissionRate', null);
      }
    },
    setStaffNo() {
      if (this.formData.id) {
        return;
      }
      this.$http({
        url: '/buz/userBase/generateIfaStaffNo',
        type: 'GET',
        data: {
          ifaType: this.formData.ifaType
        }
      }).then(res => {
        this.$set(this.formData, 'staffNo', res.data);
      });
    },
    changeLeaderId(val) {
      let item = this.groupUserList.find(i => i.id == val);
      console.log(item);
      this.$set(this.formData, 'groupId', item.groupId);
      this.$set(this.formData, 'groupName', item.groupName);
    },
    // 修改团队
    changeGroupId() {
      // 机构下直接新增员工的是否团队长只能选否
      if (!this.formData.groupId) {
        this.formData.isLeader = '0';
      }
    },
    strLength() {
      return {
        required: false,
        message: '请输入正确的护照号',
        trigger: 'change',
        validator(rule, value) {
          if (!value) return true;
          if (value.length != 8 && value.length != 9) {
            return false;
          }
          return true;
        }
      };
    },
    getCardType() {
      this.$http({
        url: '/system/dic/read/dicList',
        type: 'POST',
        data: {
          code: 'USER_CARD_TYPE'
        }
      }).then(res => {
        this.idTypeList = res.data;
      });
    },
    getBusserList() {
      this.$http({
        url: '/system/users/read/list',
        type: 'POST',
        data: {
          pageNo: 1,
          pageSize: 999,
          userType: 4
        }
      }).then(res => {
        this.busserList = res.data || [];
      });
    },
    // 获取团队列表
    getGroupList() {
      this.$http({
        url: '/buz/groupBase/read/list',
        type: 'POST',
        data: {
          tenantId: this.formData.tenantId,
          pageSize: 999,
          pageNo: 1
        }
      }).then(res => {
        this.groupList = res.data;
        if (this.groupList.length == 1) {
          this.formData.groupId = this.groupList[0].groupId;
        }
      });
    },
    save() {
      this.normalizeSigningPinyin();
      const { required, message } = this.signNamePinyinRule;
      if (!isValidSignNamePinyin(this.formData.signNamePinyin, required)) return this.$notice.error(message);
      this.$refs.form.validate().then(isok => {
        console.log(this.formData);
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if (formData.birthday) {
          // 与其他日期字段一致，避免提交日期对象或带时区的时间字符串。
          formData.birthday = this.$units.formatDate(formData.birthday, 'yyyy-MM-dd');
        }
        if (formData.firstLicenceTime) {
          formData.firstLicenceTime = this.$units.formatDate(formData.firstLicenceTime, 'yyyy-MM-dd');
        }
        if (formData.licenceEndDate) {
          formData.licenceEndDate = this.$units.formatDate(formData.licenceEndDate, 'yyyy-MM-dd');
        }

        // 自定义佣金提交处理：为"是"时确保佣金率为数值类型，为"否"时置空不提交
        formData.customSaleCommissionRate =
          formData.isCustomCommission == '1' && formData.customSaleCommissionRate != null ? Number(formData.customSaleCommissionRate) : null;

        if (formData.date?.length) {
          formData.ifaLicenceStartDate = this.$units.formatDate(formData.date[0], 'yyyy-MM-dd');
          formData.ifaLicenceEndDate = this.$units.formatDate(formData.date[1], 'yyyy-MM-dd');
        } else {
          formData.ifaLicenceStartDate = null;
          formData.ifaLicenceEndDate = null;
        }
        formData.date = null;

        // 校验密码
        if (!formData.id) {
          if (formData.password != formData.password1) {
            return this.$notice.error('密码输入不一致');
          }
          if (!this.verification(formData.password)) {
            return;
          }
        }
        // 校验账号
        const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");
        // 新增或者解密后校验
        if ((!formData.id || formData.accountEyeShow) && regTeShu.test(formData.account)) {
          return this.$notice.error('登录账号支持输入数字、字母和汉字');
        }

        if (this.loading) {
          return;
        }
        this.loading = true;
        if (formData.password) {
          const now = this.$units.formatDate(new Date(), 'yyyyMMdd');
          formData.password = this.$units.sm4Encrypt(formData.password, now + now);
        }
        delete formData.password1;
        this.$http({
          type: 'POST',
          url: formData.id ? '/buz/userBase/edit' : '/buz/userBase/add',
          data: formData
        })
          .then(res => {
            this.visible = false;
            this.loading = false;
            this.$emit('success');
          })
          .catch(err => {
            this.loading = false;
            console.log(err);
          });
      });
    },
    getDetail() {
      this.$http({
        type: 'GET',
        url: '/buz/userBase/read/detail',
        data: { id: this.formData.id }
      }).then(res => {
        if (res.data.ifaLicenceEndDate && res.data.ifaLicenceStartDate) {
          res.data.date = [res.data.ifaLicenceStartDate, res.data.ifaLicenceEndDate];
        }
        if (!res.data.mobile) {
          this.formData.mobileEyeShow = true;
        }
        if (res.data.ifaLevel) {
          res.data.ifaLevel = res.data.ifaLevel.toString();
        }
        if (!res.data.idNo) {
          this.formData.idNoEyeShow = true;
        }
        if (res.data.email) {
          this.formData.email1 = res.data.email;
        }

        // 自定义佣金字段兼容：空值默认"否"；为"是"时佣金率转为数值，InputNumber 按 precision 显示两位小数
        res.data.isCustomCommission =
          res.data.isCustomCommission === null || res.data.isCustomCommission === undefined || res.data.isCustomCommission === ''
            ? '0'
            : String(res.data.isCustomCommission);
        res.data.customSaleCommissionRate =
          res.data.isCustomCommission == '1' && res.data.customSaleCommissionRate !== null && res.data.customSaleCommissionRate !== undefined
            ? Number(res.data.customSaleCommissionRate)
            : null;

        this.formData = { ...this.formData, ...res.data };
        this.prepareSigningPinyin();
      });
    },
    getUserList() {
      this.$http({
        type: 'POST',
        url: '/buz/userBase/read/list',
        data: {
          pageSize: 9999,
          pageNo: 1,
          isAll: 1
        }
      }).then(res => {
        let list = res.data;
        this.userList = res.data;
        this.trainerList = list.filter(item => item.id != this.formData.id);
        if (this.isIFA) {
          this.mentorList = list.filter(item => item.ifaLevel != 1 && item.ifaLevel != 2);
          this.refereeList = list;
        } else {
          this.refereeList = list.filter(item => item.id != this.formData.id);
          this.mentorList = list.filter(item => item.id != this.formData.id && item.ifaLevel != 1 && item.ifaLevel != 2);
        }
        this.groupUserList = list.filter(item => item.isLeader == 1 && item.ifaLevel != 1 && item.ifaLevel != 2);
      });
    },
    changeIfaLevel(val) {
      // this.$set(this.formData, 'ifaLevel', val);
      console.log('执行了吗', val);
      if (val == 1 || val == 2) {
        this.$set(this.formData, 'isLeader', '0');
      }
    },
    changeIsLeader(val) {
      console.log(val);
      if (val == 1 || (val == 0 && this.data.leaderId == this.formData.leaderId)) {
        this.$set(this.formData, 'leaderId', '');
      } else if (this.data.leaderId && this.data.leaderId != this.formData.leaderId) {
        this.$set(this.formData, 'leaderId', this.data.leaderId);
      }
    },
    open(data) {
      this.signNamePinyinAutoValue = '';
      console.log('data', data);
      this.data = data;
      this.loading = false;
      this.visible = true;
      this.formData = {
        groupId: data.groupId,
        orgName: data.orgName,
        tenantId: data.tenantId,
        leaderId: data.leaderId,
        groupName: data.groupName,
        status: '1',
        entryTime: '',
        isLeader: '0',
        mobile: '',
        name: '',
        // 每次打开新增或编辑弹窗时重置生日，再由详情或识别结果回填。
        birthday: '',
        signNamePinyin: '',
        idNo: '',
        idType: '',
        account: '',
        password: '',
        password1: '',
        ifaLevel: '',
        id: '',
        email: '',
        busserId: '',
        operatorName: '',
        firstLicenceTime: '',
        isLongCareer: null,
        licenceEndDate: '',
        ifaLicenceNo: '',
        ifaBusinessScope: null,
        isCustomCommission: '0',
        customSaleCommissionRate: null,
        date: null
      };
      if (data.id) {
        this.formData.id = data.id;
        this.formData.groupId = data.groupId;
        this.getDetail();
      } else {
        if (this.userInfo.isIFA) {
          this.formData.ifaType = 1;
          this.setStaffNo();
        }
      }
      this.getGroupList();
      if (this.userInfo.isIFA) {
        this.getUserList();
        this.queryWeTalkUser();
        this.getBusserList();
      }
      this.clearValidate('form');
    },
    // 查询企微用户
    queryWeTalkUser() {
      this.$http({
        type: 'GET',
        url: '/buz/userBase/queryWeTalkUser',
        data: {}
      }).then(res => {
        if (res.data) {
          this.qwUserList = res.data;
        }
      });
    },
    verification(password) {
      const capital = /[A-Z]/;
      const regLetter = /[a-z]/;
      const regNum = /[0-9]/;
      const regTeShu = new RegExp("[`_~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？+-]");

      let complex = 0;
      if (capital.test(password)) {
        ++complex;
      }
      if (regLetter.test(password)) {
        ++complex;
      }
      if (regNum.test(password)) {
        ++complex;
      }
      if (regTeShu.test(password)) {
        ++complex;
      }
      if (complex < 3 || password.length < 8 || password.length > 16) {
        this.$notice.error('密码长度8-16位，且必须包含大写字母、小写字母、数字、特殊字符中的至少三种，且不能包含账号'); //iview中的一个提示框
        return false;
      } else {
        return true;
      }
    },
    // 解密
    openEye(row, key) {
      if (!row['validName' + key]) {
        this.$refs.validUserNameRef.open(row, key);
        return;
      }
      if (!row[key + 'EyeShow']) {
        const map = {
          account: 0,
          mobile: 2,
          idNo: 1,
          email: 4
        };
        this.descrypt(
          {
            query: row.id,
            operationFunction: 1,
            operationType: map[key]
          },
          row,
          key
        ).then(() => {
          this.$set(row, key + 'EyeShow', true);
        });
      } else {
        this.$set(row, key + 'EyeShow', false);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.add-user-wrap {
  h2 {
    font-weight: 700;
    margin-bottom: 10px;
  }
  .info-text {
    font-size: 12px;
    color: #a8adb7;
    margin-left: -62px;
    margin-top: 20px;
    float: left;
  }
  .full {
    width: 100%;
  }
  /* 自定义佣金率行内布局：= [输入框] % × 收佣佣金率 */
  .commission-rate-wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    animation: commissionFadeIn 0.3s ease;

    .rate-input {
      width: 120px;
    }
    .rate-eq,
    .rate-multi,
    .rate-target {
      color: #515a6e;
    }
    .rate-symbol {
      color: #17233d;
      font-weight: 600;
    }
  }
  /* 佣金率说明文字 */
  .commission-tip {
    font-size: 12px;
    color: #a8adb7;
    line-height: 1.6;
    margin-top: 8px;
    width: 100%;
  }
}

/* 佣金率区块出现动画 */
@keyframes commissionFadeIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
